import React from "react";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import { required } from "utils/validation.util";
import TextField from "app/components/form/TextField";
import { GROUP_FORM } from "features/planner/planner.constants";

const PlanningGroupForm = ({ handleSubmit }) => {
  return (
    <form id={GROUP_FORM.ID} onSubmit={handleSubmit}>
      <Grid container>
        <Field
          required
          autoFocus
          label="Name"
          validate={[required]}
          component={TextField}
          name={GROUP_FORM.NAME}
        />
      </Grid>
    </form>
  );
};

export default PlanningGroupForm;
